import Rails from "@rails/ujs"
import { Controller } from "stimulus"
import mdkController from "./mdk_controller"
import { showOverlay, hideOverlay, scrollToFirstError } from '../services/form_helper'

export default class extends mdkController {
  static targets = ['form', 'generalError'];
  static classes = ['errorm','readonly'];
  static values = {validateurl: String, validateflag: String, networkErrorMessage: String};

  formTargetConnected(){
    const corpMailType = this.formTarget.querySelector("input[name='user[email_type]']");
    if (corpMailType != undefined){
      this.readonlyUserEmail(corpMailType);
    }
    // iOS WebKitでは写真ライブラリ由来のFileの実体読み出しが後から失敗し、multipart POSTの
    // bodyが空（Content-Length: 0）で送信されることがある（XHR・ネイティブsubmit共通。Sentry OHDR-YQ）。
    // 選択直後（一時ファイルがまだ存在する時点）に中身をメモリへ読み込み、メモリ由来のFileに
    // 差し替えることで、以後の送信がファイルハンドルに依存しないようにする。
    this.formTarget.addEventListener('change', (e) => {
      if (e.target instanceof HTMLInputElement && e.target.type === 'file') {
        this.rematerializeFileInput(e.target);
      }
    }, true);
  }

  rematerializeFileInput(input){
    const file = input.files && input.files[0];
    if (!file || !file.name) { return; }
    file.arrayBuffer().then((buf) => {
      const dt = new DataTransfer();
      dt.items.add(new File([buf], file.name, { type: file.type }));
      input.files = dt.files;
    }).catch(() => {
      // 読み込めない場合は元のFileのまま（従来挙動）。送信失敗時はFR-3のエラー表示で再試行を促す
    });
  }

  // 検証AJAX用のFormDataを構築する。
  // iOS WebKitでは写真ライブラリ由来のFileを含むFormDataをXHR送信すると、ファイル読み出しに
  // 失敗した際にエラーではなく空body（Content-Length: 0）で送信されることがある（Sentry OHDR-YQ）。
  // 検証時は実ファイルを送らず、ファイル名・種別を保持した1バイトの代理ファイルに差し替える
  // （サーバ側の存在・拡張子・サイズ下限チェックは代理ファイルでも同一に機能する）。
  // 実ファイルは本登録のネイティブsubmitでのみ送信する。
  buildValidationFormData(){
    const formData = new FormData(this.formTarget);
    for (const [key, value] of Array.from(formData.entries())) {
      if (value instanceof File && value.name) {
        formData.set(key, new File(["0"], value.name, { type: value.type }));
      }
    }
    return formData;
  }

  validate(event){
    const el = event.currentTarget;
    const pa = el.parentElement;
    const params = event.params;
    let errorM = pa.querySelector("."+this.errormClass);
    if(errorM == undefined){
      errorM = pa.parentElement.querySelector("."+this.errormClass);
    }
    const formData = this.buildValidationFormData();
    formData.append("type",params.column);
    Rails.ajax({
      url: this.validateurlValue,
      type: "POST",
      dataType: 'json',
      data: formData,
      success: (response)=> {
        errorM.innerHTML = response;
      }
    });
  }

  validateAll(onSuccessCallback, onErrorCallback, attempt = 1){
    let errorMs = document.querySelectorAll("."+this.errormClass);
    const formData = this.buildValidationFormData();
    // 観測用: 送信直前のFormData実体をクエリ文字列で申告する（bodyが消失しても届くため、
    // サーバ側の空body warning と突き合わせて原因を切り分けられる）
    let fdCount = 0, fdBytes = 0;
    for (const [, v] of formData.entries()) {
      fdCount++;
      fdBytes += (v instanceof File) ? v.size : String(v).length;
    }
    const debugUrl = this.validateurlValue + (this.validateurlValue.includes('?') ? '&' : '?') +
      `_fd_count=${fdCount}&_fd_bytes=${fdBytes}`;
    const flag = document.getElementById(this.validateflagValue);
    Rails.ajax({
      url: debugUrl,
      type: "POST",
      dataType: 'json',
      data: formData,
      error: (response)=> {
        // 空body等の一過性の送信失敗は、接続を張り直した再送でほぼ成功するため1回だけ自動リトライする
        if(attempt < 2){
          setTimeout(()=> this.validateAll(onSuccessCallback, onErrorCallback, attempt + 1), 500);
          return;
        }
        flag.value = 'false';
        this.showGeneralError(response);
        if(typeof onErrorCallback == 'function'){
          onErrorCallback();
        }
      },
      success: (response)=> {
        this.clearGeneralError();
        if(Object.keys(response).length > 0){
          Object.keys(response).forEach(function (key) {
            errorMs.forEach(function (m) {
              if (m.dataset.errormtarget == key){
                m.innerHTML = response[key];
              }
            })
          });
          flag.value = 'false';
          if(typeof onErrorCallback == 'function'){
            onErrorCallback();
          }
        }else{
          flag.value = 'true';
          if(typeof onSuccessCallback == 'function'){
            onSuccessCallback();
          }
        }
      }
    });
  }

  showGeneralError(response){
    if(!this.hasGeneralErrorTarget){ return; }
    const message = (response && response.error) || this.networkErrorMessageValue;
    this.generalErrorTarget.innerHTML = message;
  }

  clearGeneralError(){
    if(!this.hasGeneralErrorTarget){ return; }
    this.generalErrorTarget.innerHTML = '';
  }

  onSubmit(){
    const flag = document.getElementById(this.validateflagValue);
    if(flag.value == 'true'){
      this.formTarget.submit();
    }
  }

  validateAndSubmit(event){
    const el = event.currentTarget;
    const target = this.formTarget;
    showOverlay();
    this.validateAll(function(){
      el.disabled = true;
      target.submit();
    }, function(){
      hideOverlay();
      scrollToFirstError('error-message');
    })
  }
  validateAndRegisterAndSubmit(event) {
    const el = event.currentTarget;
    const _this = this
    showOverlay();
    this.validateAll(function () {
        _this.register(function () {
          el.disabled = true;
          _this.formTarget.submit();
        })
      }, function(){
        hideOverlay();
        scrollToFirstError('error-message');
      }
    )
  }

  corpMail(e){
    const el = e.currentTarget;
    this.readonlyUserEmail(el);
  }
  readonlyUserEmail(el){
    const userMail = this.formTarget.querySelector("#user_email");
    if(el.value == "1"){
      userMail.classList.add(this.readonlyClass);
      userMail.readOnly = true;
    }else{
      userMail.classList.remove(this.readonlyClass);
      userMail.readOnly = false;
    }
  }
}
